import { Link } from "react-router-dom";
import { get_started_constants } from "./constants";

const GetStarted = () => {
  return (
    <section className="bg-white  py-16 lg:py-20">
      <div className="relative bg-[#084DC5] lg:rounded-[20px] px-3 md:!px-[40px] py-3 overflow-hidden container">
        <div className="absolute left-0 bottom-0">
          <img
            src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204903/powerdbyai/Line_pattern_v6mo2z.png"
            alt="Background pattern"
          />
        </div>

        <div className="relative  flex flex-col sm:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-white">
            <h2 className="text-[22px] lg:text-[44px] font-bold">
              {get_started_constants.title}
            </h2>

            <p className="my-3 md:my-[23px] text-sm">
              {get_started_constants.description}
            </p>

            <div className="space-y-3 mb-[35px]">
              {get_started_constants.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <get_started_constants.CheckIcon />
                  <span className="text-[#EDF8FF] text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <Link
              className="border border-primary_alt bg-white px-4 py-2.5 rounded-lg h-max block text-primary_alt font-medium w-max"
              to="/signup"
            >
              Start Your AI Journey
            </Link>
          </div>

          <div className="flex-shrink-0 w-full lg:w-auto max-w-md lg:max-w-[565px]  lg:mr-14">
            <img
              src={get_started_constants.image}
              alt="Rocket launch illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
